import "@fortawesome/fontawesome-free/css/all.min.css";
import { useState } from "react";

function Webwasa() {
  const [activeTab, setActiveTab] = useState("methodology");

  return (
    <div>
      {/* -- Banner sec ---- */}
      <div className="page-banner-area">
        <h2>Services</h2>
        <div className="breadcrumbs-services">
          <ul>
            <li>
              <a href="/">Home</a>
            </li>
            <li> DPDP Audit </li>
          </ul>
        </div>
      </div>
      {/* -- Banner sec ---- */}

      {/* ---- About service section ----- */}
      <div className="about-services-wrap">
        <div className="container-fluid">
          <div className="row">
            <div className="col-lg-12">
              {/* headings */}
              <div className="heading-in mb-5">
                <h1>DPDP Audit</h1>
                <p>
                  <b className="sub-heading">Introduction</b>
                  <br />
                  The Digital Personal Data Protection (DPDP) Act, 2023
                  establishes a legal framework in India for the responsible
                  handling of personal data. A DPDP Audit helps organizations
                  assess their data collection, processing, storage, and sharing
                  practices to ensure compliance with the Act. At [Your Company
                  Name], we conduct end-to-end DPDP Audits to help businesses
                  safeguard personal data, avoid penalties, and build trust with
                  customers by demonstrating transparency and accountability.
                </p>
              </div>
              {/* headings */}

              <div className="service-card-heading">
                <h1>Why It Matters</h1>
              </div>
              <div className="services-cards-wp">
                <div className="service-box">
                  <div className="service-icon">
                    <i className="fa-solid fa-arrows-down-to-people"></i>
                  </div>
                  <div className="service-card-content">
                    <h3>Regulatory Compliance </h3>
                    <p>
                      Mandatory for organizations handling personal data in
                      India under the DPDP Act.
                    </p>
                  </div>
                </div>
                <div className="service-box">
                  <div className="service-icon">
                    <i className="fa-solid fa-database"></i>
                  </div>
                  <div className="service-card-content">
                    <h3>Avoid Penalties </h3>
                    <p>
                      Prevent heavy fines for non-compliance and data misuse.
                    </p>
                  </div>
                </div>
                <div className="service-box">
                  <div className="service-icon">
                    <i className="fa-solid fa-shield-halved"></i>
                  </div>
                  <div className="service-card-content">
                    <h3>Data Subject Rights </h3>
                    <p>
                      Ensure compliance with user rights such as consent, data
                      access, correction, and erasure.
                    </p>
                  </div>
                </div>
                <div className="service-box">
                  <div className="service-icon">
                    <i className="fa-solid fa-table"></i>
                  </div>
                  <div className="service-card-content">
                    <h3>Trust & Transparency </h3>
                    <p>
                      Build stronger customer confidence with responsible data
                      handling.
                    </p>
                  </div>
                </div>
                <div className="service-box">
                  <div className="service-icon">
                    <i className="fa-solid fa-business-time"></i>
                  </div>
                  <div className="service-card-content">
                    <h3>Global Alignment </h3>
                    <p>
                      Supports compliance with GDPR, ISO 27701, and other data
                      privacy regulations.
                    </p>
                  </div>
                </div>
              </div>

              {/*-------- TAB AND PILL SEC ----------- */}
              <div className="tab-pill-sec-main">
                <div className="tab-inner-contain">
                  <ul className="nav nav-pills">
                    <li className="nav-item">
                      <button
                        className={`nav-link${activeTab === "methodology" ? " active" : ""}`}
                        onClick={() => setActiveTab("methodology")}
                      >
                        Methodology
                      </button>
                    </li>
                    <li className="nav-item">
                      <button
                        className={`nav-link${activeTab === "keybenefits" ? " active" : ""}`}
                        onClick={() => setActiveTab("keybenefits")}
                      >
                        Key Benefits
                      </button>
                    </li>
                    <li className="nav-item">
                      <button
                        className={`nav-link${activeTab === "deliverables" ? " active" : ""}`}
                        onClick={() => setActiveTab("deliverables")}
                      >
                        Deliverables
                      </button>
                    </li>
                  </ul>

                  <div className="tab-content" id="ex2-content">
                    <div
                      className={`tab-pane fade${activeTab === "methodology" ? " show active" : ""}`}
                      role="tabpanel"
                    >
                      <p>
                        Our DPDP Audit framework follows a structured approach:
                      </p>
                      <ul>
                        <li>
                          <b>Scope & Data Mapping :-</b> – Identify personal and
                          sensitive personal data processed by the organization.
                        </li>
                        <li>
                          <b>Consent & Privacy Review :-</b> Assess consent
                          mechanisms, privacy notices, and lawful processing.
                        </li>
                        <li>
                          <b>Data Security Assessment :-</b> Evaluate technical
                          and organizational safeguards protecting personal
                          data.
                        </li>
                        <li>
                          <b>Rights Management Check :-</b> Verify processes for
                          data subject rights (access, correction, deletion,
                          withdrawal of consent).
                        </li>
                        <li>
                          <b>Third-Party Risk Review :-</b> Assess data sharing
                          practices with vendors, partners, and processors.
                        </li>
                        <li>
                          <b>Gap Analysis & Compliance Mapping :-</b>
                          Identify gaps against DPDP Act requirements.
                        </li>
                        <li>
                          <b>Remediation & Action Plan :-</b>
                          Provide recommendations and roadmap for compliance
                          readiness.
                        </li>
                      </ul>
                    </div>

                    <div
                      className={`tab-pane fade${activeTab === "keybenefits" ? " show active" : ""}`}
                      role="tabpanel"
                    >
                      <ul>
                        <li>Ensure compliance with India’s DPDP Act, 2023.</li>
                        <li>Avoid regulatory fines and reputational damage.</li>
                        <li>
                          Build customer trust through transparent data
                          handling.
                        </li>
                        <li>
                          Align with global privacy frameworks for
                          multi-jurisdictional operations.
                        </li>
                        <li>Improve data governance and security posture.</li>
                      </ul>
                    </div>

                    <div
                      className={`tab-pane fade${activeTab === "deliverables" ? " show active" : ""}`}
                      role="tabpanel"
                    >
                      <p>You will receive:</p>
                      <ul>
                        <li>DPDP Gap Assessment Report</li>
                        <li>Personal Data Inventory & Mapping Document</li>
                        <li>Consent & Privacy Policy Review Report</li>
                        <li>Data Protection Risk & Control Matrix</li>
                        <li>Audit-Ready Evidence Repository</li>
                        <li>Remediation Roadmap with Action Plan</li>
                        <li>Executive Summary for Leadership & Regulators</li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
              {/*---------- TAB AND PILL SEC ---------- */}

              {/* ------- OUR APPROACH SEC ------ */}
              <div className="our-approach-sec-main">
                <div className="container">
                  <h3>Our Approach </h3>
                  <ul>
                    <li>
                      <b>Expertise in Privacy & Security :-</b> Specialists in
                      DPDP, GDPR, HIPAA, and ISO 27701.
                    </li>
                    <li>
                      <b>End-to-End Compliance Partner :-</b> From readiness
                      assessment to remediation and audit preparation.
                    </li>
                    <li>
                      <b>Sector-Specific Knowledge :-</b> Experience with BFSI,
                      healthcare, SaaS, e-commerce, and IT services.
                    </li>
                    <li>
                      <b>Practical Solutions :-</b> Actionable recommendations
                      tailored to your data ecosystem.
                    </li>
                    <li>
                      <b>Trusted Advisory :-</b>
                      Proven success in enabling organizations to meet privacy
                      compliance requirements.
                    </li>
                  </ul>
                </div>
              </div>
              {/* ------- OUR APPROACH SEC ------ */}
            </div>
          </div>
        </div>
      </div>
      {/* ---- About service section ----- */}
    </div>
  );
}

export default Webwasa;
